$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
CheckItemListView = require 'app/scripts/views/checklist/check-item-list-view'
{ ChecklistEducationBanner } = require 'app/src/components/ChecklistEducationBanner'
{ ChooseDate } = require 'app/src/components/ChooseDate'
{ ChooseMember } = require 'app/src/components/ChooseMember'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
Confirm = require 'app/scripts/views/lib/confirm'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DragSort = require 'app/scripts/views/lib/drag-sort'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EmojiCompleterView = require 'app/scripts/views/internal/autocomplete/emoji-completer-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
hasSelectionIn = require 'app/scripts/lib/util/selection/has-selection-in'
{ isSubmitEvent } = require '@trello/keybindings'
Layout = require 'app/scripts/views/lib/layout'
MemberState = require 'app/scripts/view-models/member-state'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ TrelloStorage } = require '@trello/storage'
{ toggleAssignPopoverV2 } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopoverV2 } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
urls = require 'app/scripts/controller/urls'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
ninvoke = require 'app/scripts/lib/util/ninvoke'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist')


viewTitle = forNamespace('view title')

assignTemplate = t.renderable (fullName) ->
  t.icon 'add-member'
  if fullName
    t.text(fullName)
  else
    t.format('assign')

dueTemplate = t.renderable (dueText) ->
  t.icon 'clock'
  if dueText
    t.text(dueText)
  else
    t.format('due-date')

CHECKLIST_EDUCATION_BANNER = 'checklist-education-banner'

module.exports = mixin AutoInsertionView, CompleterUtil, class ChecklistView extends View
  className: 'checklist'

  initialize: ->
    @makeDebouncedMethods 'renderCheckedState', 'renderBanners'

    @listenTo @model.checkItemList,
      'add remove reset change:state': ->
        @renderProgress()
        @renderCheckedStateDebounced()
      'add remove reset': @renderBannersDebounced
      'change:state': @checkIfComplete

    @listenTo MemberState,
      'change:idCollapsedChecklists': @renderCheckedStateDebounced

    @listenTo @model,
      'change:name': @renderName
      'change:limits': @renderInput

    @listenTo @model.getCard().checklistList,
      'add remove reset sort', @renderBannersDebounced

    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @renderBannersDebounced

  events:
    # new checklist item stuff
    'keydown .js-new-checklist-item-input': 'keydownChecklistEvent'
    'keydown .js-checklist-title': 'keydownChecklistNameEvent'
    'click .js-add-checklist-item': 'submitTask'
    'click .js-cancel-checklist-item': 'cancelItemEditing'
    'click .js-new-checklist-item-button': 'editNewChecklistItem'

    # options
    'click .js-confirm-delete': 'confirmDeleteChecklist'

    'click .js-hide-checked-items': 'hideCheckedItems'
    'click .js-show-checked-items': 'showCheckedItems'

    'click .js-toggle-checklist-state': 'toggleChecklistState'

    # reorder checklist and checklist items
    'sortstop .js-checklist-items-list': 'sortStop'
    'sortreceive .js-checklist-items-list': 'sortReceive'
    'movechecklist': 'moveChecklist'

    # autocomplete stuff
    'keyup .js-new-checklist-item-input': 'keyAutoMention'
    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'

    # advanced checklists
    'click .js-assign': 'assignUpsellOrPopover'
    'click .js-due': 'dueDateUpsellOrPopover'

    # Editable View Port
    'click .js-checklist-title': 'editChecklistName'
    'click .js-save-checklist-title': 'commitEdits'
    'click .js-cancel-checklist-title': 'clearEdits'
    'click .js-discard-edits': 'clearEdits'
    'click .js-view-edits': 'editField'
    'click input': Util.stopPropagation
    'click textarea': Util.stopPropagation

  render: ->
    log('render', "rendering checklist state " + @model.get('name'))

    @$el.html(templates.fillFromModel(require('app/scripts/views/templates/checklist'), @model))
    $checkItemList = @$('.js-checklist-items-list')

    if @getCard()?.editable()
      DragSort.refreshCardSortable $checkItemList,
        axis: 'y'
        delay: '75'
        distance: '7'
        tolerance: 'pointer'
        placeholder: 'checklist-item placeholder'
        items: '.checklist-item'
        connectWith: '.js-checklist-items-list'
        start: (event, ui) ->
          DragSort.sorting = true
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)
        stop: =>
          # Must defer this for the glory of Firefox!
          @defer ->
            DragSort.sorting = false
    @$newCheckItemInput = @$('.js-new-checklist-item-input')
    @$newCheckItemButton = @$('.js-new-checklist-item-button')
    _.defer =>
      @$newCheckItemInput.autosize()

    @renderName()
    @renderCheckItems()
    @renderInput()
    @renderBanners()

    @renderCheckedState()

    @

  renderInput: ->
    overLimit = @model.isOverLimit('checkItems', 'perChecklist')
    @$('.js-new-checklist-item').toggleClass('hide', overLimit)
    @$('.js-new-checklist-item-limit-exceeded').toggleClass('hide', !overLimit)

    @

  renderName: ->
    @$('div.js-checklist-title[attr=name] .current').text(@model.get('name'))
    @

  renderProgress: ->
    countComplete = @model.getCompletedCount(@getCard())
    countTotal = @model.getCheckItemCount()
    percentComplete = if countTotal > 0 then Math.round(100.0 * countComplete / countTotal) else 0
    complete = countComplete == countTotal && countTotal > 0

    @$('.js-checklist-progress-bar').width(percentComplete + "%")
    @$('.js-checklist-progress-percent').text(percentComplete + "%")

    @$('.js-checklist-progress-bar').toggleClass('checklist-progress-bar-current-complete', complete)

    @

  _showEducationBanner: ->
    if !@model.editable()
      return false

    if Auth.me().isDismissed(CHECKLIST_EDUCATION_BANNER)
      return false

    # Only show it on the first checklist (that isn't empty)
    firstChecklistWithItems = @model.getCard().checklistList.find (checklist) ->
      checklist.checkItemList.length > 0

    if @model != firstChecklistWithItems
      return false

    return Boolean(@model.getBoard()?.hasAdvancedChecklists())

  renderBanners: ->
    if @_showEducationBanner()
      banner = React.createElement(ChecklistEducationBanner, {
        onDismiss: -> Auth.me().dismiss(CHECKLIST_EDUCATION_BANNER)
        idCard: @model.get('idCard')
        idBoard: @model.get('idBoard')
        idOrganization: @model.getBoard()?.get('idOrganization')
      })

      ReactDOM.render(banner, @el.querySelector('.js-checklist-banners'))
    else
      @clearBanners()

  clearBanners: ->
    ReactDOM.unmountComponentAtNode(@el.querySelector('.js-checklist-banners'))

  renderCheckItems: ->
    $checkItemList = @$('.js-checklist-items-list')

    checkItemListView = @collectionSubview CheckItemListView,
      @model.checkItemList, { el: $checkItemList }
    checkItemListView.render()

    DragSort.refreshIfInitialized($checkItemList)
    @renderProgress()
    @

  isChecklistCollapsed: ->
    MemberState.inSet('idCollapsedChecklists', @model.id)

  renderCheckedState: (e) ->
    countItems = @model.getCheckItemCount()
    countComplete = @model.getCompletedCount(@getCard())
    hasCheckItems = countItems > 0
    complete = countItems == countComplete && countItems > 0
    $checkIcon = @$('.js-toggle-checklist-state')

    @$('.js-show-checked-items')
    .text l('show checked items', { count: countComplete.toString() })

    @$('.js-completed-message').addClass('hide')

    if countComplete == 0 || !hasCheckItems
      @$el.removeClass('hide-completed-items')
      @$('.js-show-checked-items').addClass('hide')
      @$('.js-hide-checked-items').addClass('hide')
      @
    else if @isChecklistCollapsed()
      @$el.addClass('hide-completed-items')
      @$('.js-show-checked-items').removeClass('hide')
      @$('.js-hide-checked-items').addClass('hide')
      @$('.js-completed-message').toggleClass('hide', !complete)
    else
      @$el.removeClass('hide-completed-items')
      @$('.js-show-checked-items').addClass('hide')
      @$('.js-hide-checked-items').removeClass('hide')


    if featureFlagClient.get('treehouse.web.checklist-toggles', false)
      if @model.editable() && hasCheckItems
        $checkIcon.addClass('editable')
        if countItems == countComplete
          $checkIcon
            .addClass('icon-checkbox-checked')
            .removeClass('icon-checkbox-unchecked')
        else
          $checkIcon
            .addClass('icon-checkbox-unchecked')
            .removeClass('icon-checkbox-checked')
      else
        $checkIcon
          .removeClass('editable')
          .removeClass('icon-checkbox-checked icon-checkbox-unchecked icon-checkbox-checked')
          .addClass('icon-checkbox-checked')

    @

  hideCheckedItems: (e) ->
    Util.stop(e)
    MemberState.pushCollapsedChecklist(@model.id)
    track("Checklist", "Hide Checked Items")
    return

  showCheckedItems: (e) ->
    Util.stop(e)
    MemberState.pullCollapsedChecklist(@model.id)
    track("Checklist", "Show Checked Items")
    return

  toggleChecklistState: ->
    if !@model.editable() \
       || !featureFlagClient.get('treehouse.web.checklist-toggles', false)
      return

    countItems = @model.getCheckItemCount()
    countComplete = @model.getCompletedCount(@getCard())

    # Uncheck all
    if countItems == countComplete
      @model.toggleCheckItemsState('incomplete')
      track("Checklist", "Uncheck all items")
    # Check all
    else
      @model.toggleCheckItemsState('complete')
      track("Checklist", "Check all items")

    return

  dueDateUpsellOrPopover: (e) ->
    editable = @model.editable()
    return if !editable

    board = @model.getBoard()

    if board?.hasAdvancedChecklists()
      toggleDatePopoverV2({
        title: viewTitle('change due date')
        setDate: (date) =>
          @_newCheckitemAttributes.due = date
          @renderNewItemButtons()
          @$('.js-new-checklist-item-input').focus()
        getInitialDate: => @_newCheckitemAttributes?.due
        trackingMethod: 'by clicking due date button in checkitem composer'
      })(e)

    else if board?.upsellAdvancedChecklists()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking due date button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  assignUpsellOrPopover: (e) ->
    editable = @model.editable()
    return if !editable

    board = @model.getBoard()

    if board?.hasAdvancedChecklists()
      card = @model.getCard()
      board = @model.getBoard()

      toggleAssignPopoverV2({
        title: viewTitle('assign')
        getCardMembers: => card.memberList.filterDeactivated(force: true, model: board).toJSON()
        getBoardMembers: => board.memberList.filterDeactivated(force: true).toJSON()
        trackingMethod: 'by clicking member button in checkitem composer'
        getInitialMember: => @_newCheckitemAttributes?.idMember,
        setMember: (idMember) =>
          @_newCheckitemAttributes.idMember = idMember
          @renderNewItemButtons()
          @$('.js-new-checklist-item-input').focus()
      })(e)
    else if board?.upsellAdvancedChecklists()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking member button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  editNewChecklistItem: (e) ->
    Util.stop(e)

    board = @model.getBoard()
    showButtons = Boolean(board?.hasAdvancedChecklists() || board?.upsellAdvancedChecklists())

    @$('.js-new-checklist-item')
    .find('.js-assign,.js-due')
    .toggleClass('hide', !showButtons)

    @_newCheckitemAttributes =
      idMember: undefined
      due: undefined
    @renderNewItemButtons()

    @edit('newItem')

  renderNewItemButtons: ->
    { idMember, due } = @_newCheckitemAttributes

    fullName = @modelCache.get('Member', idMember)?.get('fullName')
    @$('.js-new-checklist-item .js-assign').html(assignTemplate(fullName))

    dueText = due && Dates.toDateString(due)
    @$('.js-new-checklist-item .js-due').html(dueTemplate(dueText))

    @

  getCard: -> @options.card

  cancelItemEditing: (e) ->
    Layout.cancelEdits()
    false

  newChecklistItemInputVisible: ->
    if (@$('.js-new-checklist-item-input').css('display') == 'none')
      return false
    else
      return true

  focusNewTaskInput: (e) ->
    if !@newChecklistItemInputVisible()
      @editNewChecklistItem(e)
    @$('.js-new-checklist-item-input').select()
    return

  keydownChecklistNameEvent: (e) ->
    if $(e.target).hasClass('js-cancel-checklist-title')
      @clearEdits()
    else if isSubmitEvent(e)
      Util.stop(e)
      @commitEdits(e)

  keydownChecklistEvent: (e) ->
    if $(e.target).hasClass('js-new-checklist-item-input')
      if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
        @checkInsert(e)

      else if isSubmitEvent(e)
        @submitTask(e)

  getTextInput: ->
    @$('.js-new-checklist-item-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  submitTask: (e) ->
    Util.stop(e)
    s = @$newCheckItemInput.val().trim()

    if /^\s*$/.test(s)
      Util.stop(e)
      @focusNewTaskInput()
      return false

    taskNames = _.compact(s.split(/\r\n|\r|\n/))
    checklist = @model

    # [LOCK]
    Promise.using checklist.modelCache.getLock(), =>
      Promise.resolve(taskNames)
      .each (name) =>
        if checklist.checkItemList.length > 0
          pos = checklist.checkItemList.last().get('pos') + Util.spacing
        else
          pos = Util.spacing

        # Also add a little bit of randomness to make it unlikely that another
        # client would send a checkitem with the exact same pos
        pos += Math.floor(Math.random() * 1024)

        idMember = @_newCheckitemAttributes?.idMember
        due = @_newCheckitemAttributes?.due

        return Promise.fromNode (next) ->
          checkItem = checklist.checkItemList.create
            name: name.trim()
            pos: pos
            nameData:
              emoji: Auth.me().allCustomEmoji()
            idMember: idMember
            due: due
          ,
            error: =>
              checklist.checkItemList.remove(checkItem)
          , next
    .done()

    @$newCheckItemInput.val("").trigger('autosize.resize')
    @focusNewTaskInput()

    multi = if taskNames.length == 1 then "Single Item" else "Multiple Items"
    track("Checklist", "Add Checklist Item", multi)

    PopOver.hide()

    return

  sortStop: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movecheckitem', [ui, @model, false])
    return

  sortReceive: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movecheckitem', [ui, @model, true])
    return

  confirmDeleteChecklist: (e) ->
    Util.stop(e)

    checklistName = @model.get('name')

    Confirm.toggle 'delete checklist',
      elem: @$(e.target).closest('.js-confirm-delete')
      model: @model
      title: l('confirm.delete checklist.title', { checklistName })
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        track("Checklist", "Delete Checklist")
        @model.destroy()

    return

  isComplete: ->
    @model.getCheckItemCount() == @model.getCompletedCount(@getCard())

  checkIfComplete: (checkItem) ->
    if !featureFlagClient.get('remarkable.checklist_congrats', false)
      return

    # Is this a list where the animation will be interesting?
    if @isChecklistCollapsed() || @model.getCheckItemCount() < 3
      return

    # Did we just finish the whole list?
    if checkItem.get('state') == 'complete' && checkItem.previous('state') == 'incomplete' && @isComplete()
      index = @model.checkItemList.indexOf(checkItem)
      @congratulations(index)

    return

  congratulations: (origin) ->
    if @_congratulationsResetTimeout
      # Another one is still in progress
      return

    $checkitems = @$('.checklist-item-checkbox')

    animations = ['pop-checkbox', 'shake-checkbox', 'spin-checkbox']
    $checkitems
    .css 'animation-delay', (index) ->
      distance = Math.abs(index - origin)
      "#{ distance * 100 }ms"
    .addClass(animations[Math.floor(Math.random() * animations.length)])

    # Prevent another animation from starting while this one is still
    # in progress (also reduces weirdness that can come in from rapidly
    # checking and unchecking the last item)
    @_congratulationsResetTimeout = @setTimeout =>
      @_congratulationsResetTimeout = null
      $checkitems
      .removeClass('pop-checkbox shake-checkbox spin-checkbox')
      .css('animation-delay', '')
    , 5000

  moveChecklist: (e, ui) ->
    card = @model.getCard()
    if card?
      checkItems = ui.item.parent().children()
      index = checkItems.index(ui.item)
      @model.update('pos', card.calcChecklistPos(index, @model))
      @model.collection.sort({ silent: true })

      track("Checklist", "Reorder Checklist")

    return

  editChecklistName: (e) ->
    return if DragSort.sorting

    $container = $(e.target).closest('.editable')

    if $container.length == 0
      return

    if hasSelectionIn($container)
      return

    Util.stop(e)
    PopOver.hide()

    attr = $container.attr('attr')

    @edit(attr)

  edit: (sAttr) ->
    if sAttr.indexOf('.') > -1
      parts = sAttr.split('.')
      sAttr = parts[1]

    allEditableWithAttr = @$("[attr=#{sAttr}]")
    noEdits = @$(".js-no-higher-edits [attr=#{sAttr}]")
    container = allEditableWithAttr.not(noEdits)
    return if (container.length == 0)

    Layout.cancelEdits()
    edit = container.find('.edit:first')
    return if (edit.length == 0)

    input = container.find('.field:first')
    isTextArea = input.is('textarea')
    isCardDesc = input.parent().is('.card-detail-edit')
    current = container.find('.current')

    container.addClass('editing')

    if input.val() == ""
      input.val(Util.traverse(@model.attributes, parts ? sAttr))

    @waitForId @model, =>
      input.data('draftKey', @_draftKey(sAttr))

    log('editable', @model)

    input.focus().select()

    input.autosize(append: false)
    return

  clearEdits: (e) ->
    Util.stop(e)
    $editable = $(e.target).closest('.editable[attr]')
    attr = $editable.attr('attr')
    if attr?
      @_discardDraft(attr)
    $editable.find('.field').val("")
    $editable.find('.edits-warning').hide()
    $editable.find('.edits-error').hide()
    $editable.removeClass('editing')
    Layout.cancelEdits()
    false

  commitEdits: (e) ->
    Util.stop(e) if e

    $editable = $(e.target).closest('.editable.editing[attr]')
    $editable.find('.edits-error').hide()

    if !@validate()
      return

    view = @
    model = @model
    customSet = @customSet

    # Remove buttons
    $editable.remove('input[type=submit]')

    # Remove buttons and commit all other edits
    $editable
    .removeClass('editing')
    .each(->
      attr = $(this).attr('attr')
      newValue = $(this).find('.field').val()

      if !view.allowNewlines
        newValue = newValue.replace(/[\r\n]+/g, ' ')

      # if the newValue is all whitespace, replace it with the empty string
      if $.trim(newValue).length == 0
        newValue = ""

      if model.get(attr) == newValue
        view._discardDraft(attr)
      else
        model.update attr, newValue, (err) ->
          if err?
            $editable.find('.edits-error').text(err.message).show()
            view._saveDraft(attr, newValue)
          else
            view._discardDraft(attr)
          return
    )
    .find('.field').val("")

    $editable.find('.edits-warning').hide()

    true

  validate: ->
    for field in @$('.editing.non-empty .field')
      if /^\s*$/.test($(field).val())
        return false

    for field in @$('.editing .field')
      fieldLength = ($(field).val() ? '').length
      if fieldLength > 16384
        $('.editing')
        .find '.edits-error'
        .text l('text too long', { over: asNumber(fieldLength - 16384) })
        .show()
        return false

    true

  editField: (e) ->
    $link = $(e.target).closest('a')
    return if ($link.length > 0 && $link.attr('href') != '#')
    return if DragSort.sorting

    $container = $(e.target).closest('.editable')
    if $container.length == 0
      return

    # If they've selected some text, they're probably trying to copy it
    if hasSelectionIn($container)
      return

    Util.stop(e)
    PopOver.hide()

    attr = $container.attr('attr')

    @edit(attr)

  _draftKey: (attr) -> "draft_#{ @model.id }_#{ attr }"
  _saveDraft: (attr, value) -> TrelloStorage.set(@_draftKey(attr), value)
  _recallDraft: (attr) -> TrelloStorage.get(@_draftKey(attr))
  _discardDraft: (attr) -> TrelloStorage.unset(@_draftKey(attr))


  saveDrafts: (invokeSource) ->
    return false if !@model.id?
    for $el in @getEdits()
      attr = $el.attr('attr')
      val = $el.find('.field:first').val()
      continue if $.trim(val).length == 0 # Not in edit mode
      if @model.get(attr) != val && val != @_recallDraft(attr)
        if invokeSource
          track('Editable View', 'Save Draft', "Save draft via #{invokeSource}")
          trackUe('Editable View', 'Save Draft', '', '', '', "when #{invokeSource}", '')
        @_saveDraft(attr, val)

  getEdits: ->
    $allEdits = @$('[attr]')
    # Make sure we don't process other editables that are nested
    # inside this one
    $noEdits = @$('.js-no-higher-edits [attr]')

    $allEdits.not($noEdits).map (index, el) => $(el)

  remove: ->
    @clearBanners()
    @saveDrafts('removing view')
    $(window).off ".EditableView-#{@model.cid}"
    super

# [LOCK]
#
# This looks unnecessary, since `create` is going to lock the modelCache as
# well. However, there is a brief period of time in between creations where it
# will unlock, then map a potentially old delta (that contains the entire list
# of checkitems, of course, because that's how checkitem deltas work), then the
# next time around the function that calculates the new pos will have stale
# data, as by mapping an older delta we've effectively "uncreated" the previous
# check item in the list. The net effect is that, without this outer lock,
# check items can show up in the wrong order.
